import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Initialize from local storage
    useEffect(() => {
        const token = localStorage.getItem('token');
        const storedUser = localStorage.getItem('user');

        if (token && storedUser) {
            try {
                setUser(JSON.parse(storedUser));
            } catch {
                setUser(null);
            }
        }
        setLoading(false);
    }, []);

    // Sync auth state reactively when:
    // 1. Another tab removes/sets the token (storage event)
    // 2. Same-tab logout via removeItem without calling context logout()
    useEffect(() => {
        const syncAuth = () => {
            const token = localStorage.getItem('token');
            const storedUser = localStorage.getItem('user');
            if (token && storedUser) {
                try { setUser(JSON.parse(storedUser)); } catch { setUser(null); }
            } else {
                setUser(null);
            }
        };

        // Cross-tab sync (fires in other tabs when localStorage changes)
        window.addEventListener('storage', syncAuth);
        // Same-tab sync — dashboards dispatch this after removeItem
        window.addEventListener('authChange', syncAuth);

        return () => {
            window.removeEventListener('storage', syncAuth);
            window.removeEventListener('authChange', syncAuth);
        };
    }, []);

    const login = (userData, token) => {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
        window.dispatchEvent(new Event('authChange'));
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
        window.dispatchEvent(new Event('authChange'));
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
